import axios from './Axios';
import HelpdeskGraphQL from "./HelpdeskGraphQL";
const { USER_MANGER_URL} = require('../config')

class User  extends HelpdeskGraphQL {

    static async fetchAllUsers(tenantId) {

        return await axios()({
            url: USER_MANGER_URL + `?token=messenger&tenantId=${tenantId}`,
            method: 'GET',
            responseType: 'json'
        })

    }
}

export default User;
